export default "__VITE_ASSET__BmRMre1e__"